import React from "react";
import { Form, Image } from "react-bootstrap";
import { toast } from "react-toastify";
import DefaultImage from "../../../assets/img/DefaultProduct.jpg";
import LoaderImage from "../../../assets/img/spinner_transferent.svg";
import DownloadImage from "../../../assets/img/download.png";
import UploadImageIcon from "../../../assets/img/uploadImage.png";
import { useState } from "react";
import CommonModal from "../../Common/CommonModal";



const FileUploader = ({
  label,
  name,
  type,
  value, 
  onUpload,
  onDelete,
  isMultiple = false,
  required = false,
  uploadFileLoader =false,
  error = false,
  isDownload = false,
  isCancel = false,
  isLimit = 5, 
  maxFileSize = isLimit * 1024 * 1024, 
  infoMsg = "",
  infoIcon=false
  
}) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Validate file type
    const validFormats = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
    if (!validFormats.includes(file.type)) {
      toast.error("Invalid file type. Please select a JPG, PNG, or WEBP file.");
      return;
    }

    // Validate file size
    if (file.size > maxFileSize) {
      toast.error(`File size should not exceed ${isLimit}MB`);
      return;
    }

    onUpload(file,e.target?.dataset?.index);
  };
    const [ showModal, setShowModal ] = useState({
        open: false,
        title: "",
        modalType: "",
        Data: {}
    });
    const obj = {
      name:name,
      value:value
    }
  const RemoveImagePopup = (Campaign) => {
    setShowModal({
        ...showModal,
        open: !showModal?.open,
        title: "Are you sure?",
        description: "Are you certain you want to delete this image? Removing it will permanently delete the image from the live website.",
        modalType: "not form",
        button: "Remove Image",
        category: "Remove Image",
        Data: Campaign
    });
};
  const RemoveImage = () =>{
    if(isCancel){
    RemoveImagePopup(obj)
    }else{
      onDelete()
    }
  }
  return (
    <>
<div className="row">
      <div className="col-md-4">
        <div className="formgroups">
          <h4 className={required ? "label-required font-size d-flex" : "font-size d-flex"}>{label}
          {(infoMsg && infoIcon)&&(
              <div className="toolktis">
                <span className="erroMessagwrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-info-circle-filled"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                      strokeWidth="0"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
                <div className="tooltpimessae" style={{ width: "162px" }}>
                  {infoMsg}
                </div>
              </div>
              )}
          </h4>
        </div>
      </div>
      <div className="col-md-8">
        <Form.Group className="mb-3">
         {(value !== undefined && value !== "" && !isMultiple && value!==null) ? (
          <div style={{display:"flex",gap:"20px"}}>
          <div className="imageuploads">
            <Image src={value?.file_url_400} alt="charity avatar" />
                <span className="closeIcon" onClick={RemoveImage}></span>
            </div>
            {isDownload &&(
            <a href={value?.file_url_400} style={{display:"flex",height:"30px",width:"30px",objectFit:"contain",cursor:"pointer"}}>
            <Image src={DownloadImage} alt="Download Image"  style={{height:"100%"}}/>
            </a>)}
         </div>):
          <div className="uploadbuttons me-2 mb-2" onClick={() => document.getElementById(name)?.click()}>
            <div className={uploadFileLoader ? "fileloader active" : "fileloader"}>
              {uploadFileLoader ? (
                <Image src={LoaderImage} className="uploadImgIconse uploadimagload" alt="upload image" />
              ) : (
                <>
                  <Image src={UploadImageIcon} className="uploadImgIconse" alt="upload image" />
                  <input
                      type="file"
                      id={name}
                      className="uploadfilInput"
                      onChange={(e) => handleFileChange(e)} 
                      accept=".svg, .png, .jpg, .jpeg, .webp"
                      multiple={isMultiple ? true : false}
                  />
                </>
              )}
            </div>
            <div className="uploadfilebox">
              <Image src={DefaultImage} alt="upload image" />
            </div>
          </div>
         }

          {isMultiple ? (
            <div className="d-flex flex-wrap">
              {(Array.isArray(value) ? value : [])?.map((item, index) => (
                <div key={index} className="imageuploads bg-grey me-2 mb-2">
                  <Image src={item?.file_url_400} alt="uploaded" />
                  <span className="closeIcon" onClick={() => onDelete(index)}></span>
                </div>
              ))}
            </div>
          ) :null}
          {error && <div className="danger-colorset mt-1">{error}</div>}
        </Form.Group>
      </div>
    </div>
        {showModal?.open && (<CommonModal  callBack={()=>onDelete()} showModal={showModal} setShowModal={setShowModal} />)}   
    </>
  );
};

export default FileUploader;
